import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DriverShell from "../components/DriverShell";
import { authenticatedApi } from "../lib/api";
import { getDriverSession } from "../lib/driverSession";

export default function DriverCompletedPage() {
  const driver = getDriverSession();
  const [params] = useSearchParams();
  const deliveredReference = params.get("delivered");
  const [food, setFood] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!driver?.auth_token) return;
    Promise.all([
      authenticatedApi("/delivery/get-completed-orders", driver.auth_token, { method: "POST", body: "{}" }),
      authenticatedApi("/delivery/service-orders", driver.auth_token, { method: "POST", body: "{}" }),
    ])
      .then(([foodResponse, serviceResponse]) => {
        setFood(foodResponse?.data || []);
        setServices(serviceResponse?.completed_orders || []);
      })
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [driver?.auth_token]);

  return (
    <DriverShell>
      <div className="driver-page-heading"><small>ACTIVIDAD</small><h1>Historial completado</h1></div>
      {deliveredReference && (
        <div className="food-message food-message--success">
          <b>Entrega confirmada correctamente</b>
          <span>El pedido {deliveredReference} pasó al historial.</span>
        </div>
      )}
      {loading && <div className="food-message"><b>Cargando historial…</b></div>}
      {error && <div className="food-message food-message--error"><b>{error}</b></div>}
      <section className="driver-history">
        {food.map((entry) => (
          <article key={`food-${entry.id}`}>
            <span>🍽️</span><div><b>{entry.order?.unique_order_id}</b><small>{entry.order?.address}</small></div><strong>S/ {Number(entry.order?.payable || 0).toFixed(2)}</strong>
          </article>
        ))}
        {services.map((order) => (
          <article key={`service-${order.id}`}>
            <span>{order.service_type === "TAXI" ? "🚕" : "📦"}</span><div><b>{order.reference}</b><small>{order.dropoff_address}</small></div><strong>S/ {Number(order.moto_net_amount || 0).toFixed(2)}</strong>
          </article>
        ))}
        {!loading && !food.length && !services.length && <div className="food-message"><b>Aún no hay servicios completados.</b></div>}
      </section>
    </DriverShell>
  );
}
